import { reservationAxios } from '../../../core/rest/axios';
export async function loadIndividualForm(activityId, branchId) {
    return reservationAxios.get('/individualniformulare', { params: { pobockaId: branchId, cinnostId: activityId } })
        .then((response) => response.data);
}
